import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  // Based on https://stackoverflow.com/a/49041392/57950
  // and https://stackoverflow.com/a/53880407/57950

  static targets = ['table', 'th'];
  static values = { id: String };

  connect() {
    for (const element of this.thTargets) {
      element.classList.add('sortable', 'cursor-pointer', 'whitespace-nowrap');
      element.onclick = (e) => this.toggle(e);

      if (element.classList.contains('descending')) this.asc = false;
      else if (element.classList.contains('ascending')) this.asc = true;
    }

    this.restoreState();
  }

  toggle(event) {
    this.asc = !this.asc;

    const th = event.target;
    this.updateClasses(th);

    Array.from(this.tbody.querySelectorAll('tr'))
      .sort(
        this.comparer(Array.from(th.parentNode.children).indexOf(th), this.asc),
      )
      .forEach((tr) => this.tbody.appendChild(tr));

    this.saveState();
  }

  comparer(idx, asc) {
    return (a, b) =>
      ((v1, v2) =>
        v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2)
          ? v1 - v2
          : v1.toString().localeCompare(v2))(
        this.getCellValue(asc ? a : b, idx),
        this.getCellValue(asc ? b : a, idx),
      );
  }

  getCellValue(tr, idx) {
    let td = tr.children[idx];

    return td.dataset.sortValue || td.innerText || td.textContent;
  }

  updateClasses(th) {
    for (const element of this.thTargets) {
      element.classList.remove('ascending', 'descending');
    }

    if (this.asc) th.classList.add('ascending');
    else th.classList.add('descending');
  }

  get tbody() {
    return this.tableTarget.querySelector('tbody');
  }

  saveState() {
    if (!this.idValue) return;

    let state = null;
    for (let i = 0; i < this.thTargets.length; i++) {
      if (this.thTargets[i].classList.contains('ascending')) state = [i, 'asc'];
      else if (this.thTargets[i].classList.contains('descending'))
        state = [i, 'desc'];
    }

    const stateJson = JSON.stringify(state);
    localStorage.setItem('sort.' + this.idValue, stateJson);
  }

  restoreState() {
    if (!this.idValue) return;

    const stateJson = localStorage.getItem('sort.' + this.idValue);
    if (!stateJson) return;

    const state = JSON.parse(stateJson);
    if (!state) return;

    if (state && Array.isArray(state) && state.length === 2) {
      const index = state[0];
      const direction = state[1];
      const th = this.thTargets[index];
      if (!th) return;

      if ((direction === 'asc') != this.asc) {
        th.dispatchEvent(new Event('click'));
      } else {
        th.dispatchEvent(new Event('click'));
        th.dispatchEvent(new Event('click'));
      }
    }
  }
}
